import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '../components/base-component';
import { BlockDTO } from '../model/BlockDTO';

@Component
export class BaseBlock extends BaseComponent {
	@Prop() block: BlockDTO;
}

export default BaseBlock;
